import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';

function createData(
    id,
    chineseName,
    letter,
    gender,
) {
  return { id, chineseName, letter, gender };
}

const rows = [
  createData(1, '程蒙恩', 'C', 'M'),
  createData(2, '容錦泉', 'Y', 'M'),
  createData(3, '李健深', 'L', 'M'),
  createData(4, '陳永恆', 'C', 'M'),
  createData(5, '黎家豪', 'L', 'M'),
];

export default function MemberTable() {
  return (
    <div>
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: '100%' }} size="small">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell></TableCell>
            <TableCell>姓名</TableCell>
            <TableCell>性別</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.id}
              </TableCell>
              <TableCell>{row.letter}</TableCell>
              <TableCell>{row.chineseName}</TableCell>
              <TableCell>{row.gender}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    <TablePagination
        rowsPerPageOptions={[2,4,6]}
        component="div"
        count={rows.length}
        rowsPerPage={2}
        page={3}
        // onPageChange={handleChangePage}
        // onRowsPerPageChange={handleChangeRowsPerPage}
    />  
    </div>          
  );
}